export const FILTER_KEYS = ["from", "to", "franchise", "branch", "fulfilment", "payment_mode", "category", "sort", "amount"];
export const PRESET_DAYS = [1, 7, 30, 90];

const shift = (iso, days) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

export const presetRange = (dataThrough, days) => (dataThrough ? { from: shift(dataThrough, -(days - 1)), to: dataThrough } : null);

export const matchingPresetDays = (from, to, dataThrough) => {
  if (!from || !to || !dataThrough) return null;
  const match = PRESET_DAYS.find((days) => {
    const preset = presetRange(dataThrough, days);
    return preset && preset.from === from && preset.to === to;
  });
  return match || null;
};

export const isDirty = (pending, applied) => FILTER_KEYS.some((key) => (pending[key] || "") !== (applied[key] || ""));
